module.exports = __webpack_public_path__ + "img/farming_13.17505a62.png";